import React from "react";
import {
    ThumbsUp,
    MessageCircle,
    Share2,

    Facebook,
    Instagram,
    Linkedin,
    Twitter,
    Send,
    Eye,
} from "lucide-react";
import { Plus} from "lucide-react";
import { Link, useNavigate } from "react-router-dom";
import img1 from '../../assets/images/ganeshji.jpg';
const AllPosts = () => {
    return (

        <div>


            <div className="container all-post-container">
   <div className="create-new-campaign-header">
                <div>
                  {/* <h2 className="create-new-campaign-title">Dashboard</h2> */}
                  <p className="create-new-campaign-subtitle">
                    Here’s an overview of your campaigns.
                  </p>
                </div>
                <Link to="/admin/createpost">
                <button className="create-new-campaign-btn">
                  <Plus size={18} /> Create Post
                </button></Link>
              </div>
                <div className="row">
                    {/* Card */}
                    <div className="col-12 col-md-6 col-lg-3 mb-4">
                        <div className="all-post-container">
                            <div className="all-post-card">

                                

                                {/* Title */}


                                {/* Image */}
                                <div className="all-post-image">
                                    <img
                                        src={img1}
                                        alt="wallet"
                                    />
                                </div>
<div className="all-post-content-box">
 <p className="all-post-title">
                                    Ready to Unlock Instant Access to Your Funds? 🌟
                                </p>


                                {/* Header */}
                                <div className="all-post-header">
                                    <div className="all-post-socials">
                                        <Facebook size={18} color="#1877F2" />
                                        <Instagram size={18} color="#E4405F" />
                                        <Linkedin size={18} color="#0A66C2" />
                                        <Twitter size={18} color="#1DA1F2" />
                                    </div>
                                   
                                </div>
                                {/* Footer */}
                                <div className="all-post-footer">
                                    <div className="all-post-col">
                                          <Eye size={18} className="all-post-eye" /> <span className="all-post-view">8.7 </span>View
                                    </div>
                                    <div className="all-post-col">
                                          <p className="all-post-date">Created: 20 Feb 2025</p>
                                    </div>
                                   
                                </div>
</div>


                               
                            </div>
                        </div>
                    </div>
<div className="col-12 col-md-6 col-lg-3 mb-4">
                        <div className="all-post-container">
                            <div className="all-post-card">

                                

                                {/* Title */}


                                {/* Image */}
                                <div className="all-post-image">
                                    <img
                                        src={img1}
                                        alt="wallet"
                                    />
                                </div>
<div className="all-post-content-box">
 <p className="all-post-title">
                                    Ready to Unlock Instant Access to Your Funds? 🌟
                                </p>


                                {/* Header */}
                                <div className="all-post-header">
                                    <div className="all-post-socials">
                                        <Facebook size={18} color="#1877F2" />
                                        <Instagram size={18} color="#E4405F" />
                                        <Linkedin size={18} color="#0A66C2" />
                                        <Twitter size={18} color="#1DA1F2" />
                                    </div>
                                   
                                </div>
                                {/* Footer */}
                                <div className="all-post-footer">
                                    <div className="all-post-col">
                                          <Eye size={18} className="all-post-eye" /> <span className="all-post-view">8.7 </span>View
                                    </div>
                                    <div className="all-post-col">
                                          <p className="all-post-date">Created: 20 Feb 2025</p>
                                    </div>
                                   
                                </div>
</div>


                               
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mb-4">
                        <div className="all-post-container">
                            <div className="all-post-card">

                                

                                {/* Title */}


                                {/* Image */}
                                <div className="all-post-image">
                                    <img
                                        src={img1}
                                        alt="wallet"
                                    />
                                </div>
<div className="all-post-content-box">
 <p className="all-post-title">
                                    Ready to Unlock Instant Access to Your Funds? 🌟
                                </p>


                                {/* Header */}
                                <div className="all-post-header">
                                    <div className="all-post-socials">
                                        <Facebook size={18} color="#1877F2" />
                                        <Instagram size={18} color="#E4405F" />
                                        <Linkedin size={18} color="#0A66C2" />
                                        <Twitter size={18} color="#1DA1F2" />
                                    </div>
                                   
                                </div>
                                {/* Footer */}
                                <div className="all-post-footer">
                                    <div className="all-post-col">
                                          <Eye size={18} className="all-post-eye" /> <span className="all-post-view">8.7 </span>View
                                    </div>
                                    <div className="all-post-col">
                                          <p className="all-post-date">Created: 20 Feb 2025</p>
                                    </div>
                                   
                                </div>
</div>


                               
                            </div>
                        </div>
                    </div>
                    <div className="col-12 col-md-6 col-lg-3 mb-4">
                        <div className="all-post-container">
                            <div className="all-post-card">

                                

                                {/* Title */}


                                {/* Image */}
                                <div className="all-post-image">
                                    <img
                                        src={img1}
                                        alt="wallet"
                                    />
                                </div>
<div className="all-post-content-box">
 <p className="all-post-title">
                                    Ready to Unlock Instant Access to Your Funds? 🌟
                                </p>


                                {/* Header */}
                                <div className="all-post-header">
                                    <div className="all-post-socials">
                                        <Facebook size={18} color="#1877F2" />
                                        <Instagram size={18} color="#E4405F" />
                                        <Linkedin size={18} color="#0A66C2" />
                                        <Twitter size={18} color="#1DA1F2" />
                                    </div>
                                   
                                </div>
                                {/* Footer */}
                                <div className="all-post-footer">
                                    <div className="all-post-col">
                                          <Eye size={18} className="all-post-eye" /> <span className="all-post-view">8.7 </span>View
                                    </div>
                                    <div className="all-post-col">
                                          <p className="all-post-date">Created: 20 Feb 2025</p>
                                    </div>
                                   
                                </div>
</div>


                               
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default AllPosts;
